<template>
  <div class="door">
    <div
      v-if="closed"
      :class="{closed: closed, doorcontainer: true, opened: opened }"
      v-tooltip="{ loadingContent: 'Lataa', content: this.timeLeft,  delay: { show: 400, hide: 100 } }"
      @mouseover="updateTimeLeft()"
    >
      <div class="face front">{{doornumber}}</div>
      <div class="face back" />
    </div>

    <div
      v-else
      :class="{closed: closed, doorcontainer: true, opened: opened}"
      @click="openDoor(this)"
    >
      <div class="face front">{{doornumber}}</div>
      <div
        class="face back"
        :style="{backgroundImage: 'url(' + this.image + ')'}"
        @click="if (opened) showModal = true;"
        title="Avaa suurena"
      />
    </div>

    <div v-if="showCompleteMessage" class="underside fullMessage">
      <h4 v-if="!initiallyclosed">{{heading}}</h4>
      <p v-if="!initiallyclosed" :class="{opened: opened }">{{message}}</p>
    </div>
    <div v-else class="underside">
      <p v-if="!initiallyclosed">{{heading}}</p>
    </div>
    <div v-if="showModal" class="modal" v-scroll-lock="showModal">
      <img :src="image" v-click-outside="onClickOutside" />
      <p>Päivä {{doornumber}}</p>
      <h4>{{heading}}</h4>
      <p>{{message}}</p>
      <p class="whattodo">Etsi rakennus Karanteenista ja suorita päivän tehtävä!</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "CalendarDoor",
  data() {
    return {
      showModal: false,
      closed: this.initiallyclosed,
      openingDate: new Date(
        this.year,
        this.month - 1,
        parseInt(this.doornumber)
      ),
      opened: false,
      timeLeft: null
    };
  },
  props: {
    doornumber: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      default: "Sieltä se joulu tulla tupsahtaa"
    },
    heading: {
      type: String,
      default: "Sieltä se joulu tulla tupsahtaa"
    },
    image: {
      type: String
    },
    initiallyclosed: {
      type: Boolean
    },
    open: {
      type: Boolean
    },
    year: {
      type: Number,
      required: true
    },
    month: {
      type: Number,
      required: true
    },
    showCompleteMessage: {
      type: Boolean
    }
  },
  methods: {
    openDoor: function() {
      if (this.closed) return;
      localStorage["door" + this.doornumber] =
        "" + this.doornumber + this.month + this.year;
      this.opened = true;
      if (!this.image) return;
    },
    onClickOutside() {
      this.showModal = false;
    },
    timeDiff(d, ad) {
      let dist = Math.abs(d - ad);
      let days = Math.floor(dist / (1000 * 60 * 60 * 24));
      let hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((dist % (1000 * 60)) / 1000);
      return { days, hours, minutes, seconds };
    },
    updateTimeLeft: function() {
      if (!this.initiallyclosed) return;
      let diff = this.timeDiff(
        this.openingDate.getTime(),
        new Date().getTime()
      );
      let text = "";
      if (diff.days > 1) {
        text = "Aukeamiseen " + diff.days + " päivää";
      } else if (diff.hours > 1 && diff.days > 0) {
        text =
          "Aukeamiseen " + diff.days + " päivä ja " + diff.hours + " tuntia";
      } else if (diff.hours > 1) {
        text = "Aukeamiseen " + diff.hours + " tuntia";
      } else {
        text = "Luukku aukeaa piakkoin";
      }
      this.timeLeft = text;
    },
    openedBefore() {
      if (
        localStorage["door" + this.doornumber] ===
        "" + this.doornumber + this.month + this.year
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.opened = this.openedBefore();
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  padding: 1em;
  box-sizing: border-box;
  text-align: center !important;
}

.modal img {
  max-height: 60vh;
  max-width: 90vw;
  object-fit: contain;
}

.modal p {
  text-align: center;
  font-weight: 200;
}

.modal h4 {
  font-size: 1.4em;
}

.modal, .modal p {
  color: white;
}

p.whattodo {
  color: #ec4e4e;
  font-weight: 600;
}

.doorcontainer {
  height: 12em;
  width: 12em;
  box-sizing: border-box;
  transform-style: preserve-3d;
  position: relative;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  will-change: transform;
  transition: transform 1s;
  transition-timing-function: ease;
  margin: 1em;
  margin-bottom: 0;
  cursor: pointer;
}

.underside.fullMessage h4 {
  margin: 0.3em 0;
  margin-bottom: 0.5em;
}

.underside {
  width: 10em;
  height: 60px;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.8em;
  margin-top: 0.7em;
  text-align: center;
  box-sizing: content-box;
}
.underside p {
  font-size: 1rem;
  margin: 0;
}

.underside.fullMessage {
  height: auto;
  text-align: left;
}

.underside.fullMessage p {
  opacity: 0;
  transition: opacity 1s ease;
}

.underside.fullMessage p.opened {
  opacity: 1;
}

.door {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: hsla(224, 8%, 78%, 0.2);
  border-radius: 0.5em;
  margin: 0.7em;
  box-sizing: border-box;
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.doorcontainer.opened {
  transform: rotateY(180deg);
  cursor: initial;
}

.opened .face.back {
  pointer-events: initial;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: cover;
}

.opened .face.front {
  pointer-events: none;
}

.daily-image.button {
  font-size: 1.1em;
  background-color: rgba(193, 51, 51, 1);
}

.daily-image.button:hover,
.daily-image.button:active {
  background-color: hsl(0, 58%, 53%);
}

.face {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  backface-visibility: visible;
  border-radius: 50%;
  transition: transform 1s;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1),
    0 2px 4px 0 rgba(14, 30, 37, 0.12);
  backface-visibility: hidden;
}

.face.front {
  background-color: #3e8f3e;
  z-index: 2;
  font-size: 6em;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.closed .face.front {
  background-color: #2c572d;
  opacity: 0.8;
  cursor: initial;
  pointer-events: none;
  color: #1f2020;
}

.closed .face.back {
  pointer-events: none;
}

.closed.doorcontainer {
  cursor: initial;
}

.face.back {
  background-color: #1f2243;
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
  background-size: contain;
  justify-content: center;
}

@keyframes rotate {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(180deg);
  }
}

@media screen and (max-width: 600px) {
  .doorcontainer {
    height: 10em;
    width: 10em;
  }
}
</style>
